module.exports = __webpack_public_path__ + "img/accident_back.f14bb530.svg";